import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Fixed bottom CTA bar shown on mobile only (<768px).
 * Hidden on first load; it slides in only once the hero CTA buttons
 * (#hero-mobile-cta) have scrolled out of view. On pages without a hero
 * (inner pages) it is shown by default.
 * Sits above the browser navigation bar via safe-area inset padding.
 */
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    let disconnect = null;
    // Wait a tick so the new route's DOM is present
    const raf = requestAnimationFrame(() => {
      const target = document.getElementById("hero-mobile-cta");
      if (!target) {
        setVisible(true);
        return;
      }
      setVisible(false);
      const observer = new IntersectionObserver(
        ([entry]) => setVisible(!entry.isIntersecting),
        { threshold: 0 }
      );
      observer.observe(target);
      disconnect = () => observer.disconnect();
    });

    return () => {
      cancelAnimationFrame(raf);
      if (disconnect) disconnect();
    };
  }, [pathname]);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-[9999] border-t border-black/10 bg-gradient-to-br from-[#e9a31e] to-[#f2b743] px-4 pt-3 transition-transform duration-300 ease-out md:hidden ${
        visible ? "translate-y-0" : "pointer-events-none translate-y-full"
      }`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <Link
        to="/audit"
        className="block w-full rounded-lg bg-[#0a1f3d] px-6 py-3.5 text-center text-base font-bold text-white transition-colors hover:bg-[#081831]"
      >
        Book Your Free Audit
      </Link>
    </div>
  );
}
